require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-shopify-app-discounts-you-wont-want-to-miss.json") })
        }
      }, "path---blog-shopify-app-discounts-you-wont-want-to-miss");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-shopify-app-discounts-you-wont-want-to-miss!./.cache/json/blog-shopify-app-discounts-you-wont-want-to-miss.json
// module id = 482
// module chunks = 231608221292675